var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneyGpsNavyText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 287,
    viewBox: "0 0 320 287",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M221.819 170.148L206.519 186.943C196.578 197.856 182.488 205.166 165.442 206.958C122.921 211.427 78.0982 179.87 65.3319 136.476C57.6844 110.476 63.2757 86.1308 78.1294 69.8245L93.4282 53.0308C78.5744 69.337 72.9832 93.6858 80.6307 119.682C93.3969 163.076 138.221 194.633 180.741 190.165C197.788 188.372 211.878 181.062 221.819 170.148Z",
    fill: "url(#paint0_linear_2964_3553)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M221.856 170.086C248.551 140.778 241.434 90.8242 205.958 58.51C170.483 26.1958 120.083 23.7582 93.3874 53.0654C66.6918 82.3727 73.8094 132.327 109.285 164.641C144.76 196.955 195.16 199.393 221.856 170.086Z",
    fill: "url(#paint1_linear_2964_3553)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M147.933 49.972C169.558 47.722 192.27 63.722 198.74 85.712C200.79 92.677 200.968 99.3946 199.566 105.4L181.014 162.298L131.094 112.596C126.344 107.237 122.684 100.886 120.634 93.9208C114.165 71.9308 126.383 52.2533 147.933 49.972ZM168.234 118.858C183.984 117.202 192.921 102.83 188.193 86.7533C183.464 70.677 166.859 58.982 151.106 60.6383C135.354 62.2945 126.413 76.667 131.144 92.7496C135.875 108.832 152.476 120.515 168.234 118.858Z",
    fill: "url(#paint2_linear_2964_3553)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M131.094 112.596C126.344 107.237 122.684 100.886 120.635 93.9207C116.76 80.7407 119.592 68.3907 127.126 60.1207L118.849 69.2082C111.314 77.4782 108.474 89.8332 112.356 103.008C114.405 109.973 118.072 116.324 122.816 121.683L172.736 171.384L181.014 162.298L131.094 112.596Z",
    fill: "url(#paint3_linear_2964_3553)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M152.822 69.8045L152.086 67.177L149.412 69.6608L150.147 72.2895L152.822 69.8045Z",
    fill: "url(#paint4_linear_2964_3553)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M156.125 78.3445C156.707 79.0075 157.127 79.7959 157.353 80.6483L157.542 81.3233L165.093 80.262L167.767 77.7783L160.215 78.8395L160.027 78.1645C159.801 77.3115 159.381 76.5224 158.799 75.8595C158.232 75.2345 157.559 74.9845 156.775 75.0895C156.237 75.1645 155.82 75.3403 155.525 75.617L152.852 78.102C153.149 77.8262 153.566 77.6499 154.102 77.5733C154.89 77.462 155.562 77.712 156.125 78.3445Z",
    fill: "url(#paint5_linear_2964_3553)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M165.933 101.822L163.258 104.307C165.41 103.746 167.071 102.922 168.239 101.836L170.913 99.3521C169.744 100.437 168.084 101.26 165.933 101.822Z",
    fill: "url(#paint6_linear_2964_3553)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M153.808 91.337C155.028 91.6182 156.171 91.917 157.236 92.2207C158.219 92.4906 159.155 92.9074 160.013 93.457C160.806 93.972 161.35 94.7457 161.638 95.767C161.867 96.5857 161.832 97.3107 161.546 97.947C161.449 98.171 161.307 98.3726 161.128 98.5395L163.803 96.0545C163.982 95.8878 164.124 95.6861 164.221 95.462C164.506 94.8257 164.541 94.1007 164.312 93.2832C164.027 92.262 163.483 91.4882 162.687 90.972C161.829 90.4229 160.892 90.0065 159.91 89.737C158.843 89.4332 157.701 89.1345 156.481 88.8532C155.252 88.5689 154.062 88.1357 152.938 87.5632C151.751 86.9471 150.691 86.112 149.813 85.102C148.868 84.0428 148.137 82.592 147.62 80.7495C146.927 78.2745 146.87 76.1836 147.45 74.477C147.793 73.4597 148.387 72.5456 149.178 71.8195L146.505 74.3045C144.357 76.2978 143.837 79.274 144.946 83.2332C145.462 85.079 146.194 86.5303 147.14 87.587C148.017 88.597 149.077 89.4317 150.265 90.047C151.389 90.6202 152.579 91.0535 153.808 91.337Z",
    fill: "url(#paint7_linear_2964_3553)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M161.939 102.383C159.106 102.467 156.795 101.951 155.008 100.837C153.22 99.7229 151.929 97.7304 151.133 94.8595L150.79 93.6345L148.115 96.1195L148.458 97.3433C149.26 100.21 150.552 102.203 152.333 103.322C153.672 104.155 155.306 104.655 157.235 104.822C157.556 104.849 157.886 104.866 158.225 104.875C158.564 104.883 158.911 104.883 159.264 104.875L160.404 108.947L164.396 108.386L167.071 105.902L163.078 106.463L161.939 102.383Z",
    fill: "url(#paint8_linear_2964_3553)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M156.08 66.6157L156.815 69.2407C159.787 69.1332 162.141 69.752 163.875 71.097C165.609 72.442 166.908 74.6682 167.771 77.7757L160.22 78.837L160.031 78.162C159.806 77.3089 159.386 76.5199 158.804 75.857C158.236 75.232 157.564 74.982 156.78 75.087C155.912 75.2078 155.357 75.5899 155.115 76.2332C154.876 76.8797 154.853 77.5862 155.049 78.247C155.345 79.3045 155.903 80.0891 156.724 80.6007C157.62 81.1488 158.592 81.56 159.61 81.8207C160.716 82.1182 161.894 82.3945 163.134 82.642C164.398 82.8982 165.624 83.3184 166.78 83.892C168.013 84.5149 169.116 85.3667 170.03 86.402C171.007 87.4853 171.77 89.0103 172.321 90.977C173.184 94.0603 173.055 96.4478 171.935 98.1395C170.815 99.8311 168.815 101.056 165.935 101.813L167.075 105.887L163.081 106.448L161.941 102.374C159.108 102.458 156.797 101.942 155.01 100.828C153.222 99.7141 151.931 97.7216 151.135 94.8507L150.792 93.6257L158.601 92.5282L158.841 93.3882C159.223 94.7491 159.732 95.652 160.367 96.097C160.997 96.5422 161.777 96.7218 162.539 96.597C163.375 96.4795 163.941 96.097 164.225 95.4595C164.509 94.822 164.545 94.0982 164.316 93.2807C164.031 92.2595 163.487 91.4857 162.691 90.9695C161.833 90.4204 160.896 90.004 159.914 89.7345C158.847 89.4307 157.705 89.132 156.485 88.8507C155.256 88.5664 154.066 88.1332 152.942 87.5607C151.755 86.9446 150.695 86.1095 149.817 85.0995C148.872 84.0403 148.141 82.5895 147.624 80.747C146.04 75.097 147.773 71.4478 152.82 69.7995L152.084 67.1745L156.08 66.6157Z",
    fill: "url(#paint9_linear_2964_3553)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8862 252.989V274.551H39.7912V256.167C39.7912 251.368 38.7912 249.748 35.2412 249.748C32.0637 249.748 30.07 251.681 30.07 256.104V274.551H20.0987V256.167C20.0987 251.368 19.0988 249.748 15.55 249.748C12.4338 249.748 10.3775 251.681 10.3775 256.104V274.551H0.40625V242.644H10.375V247.256H10.5C12.1825 244.327 15.6713 241.647 20.47 241.647C24.645 241.647 27.5738 243.953 28.8213 247.256H28.9463C31.6888 244.078 34.4925 241.647 39.665 241.647C46.085 241.647 49.8862 245.698 49.8862 252.989Z",
    fill: "#152845"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3865 275.548C60.7303 275.548 54.3115 268.506 54.3115 258.597C54.3115 248.688 60.7303 241.647 71.3865 241.647C81.9803 241.647 88.399 248.689 88.399 258.597C88.399 268.504 81.9803 275.548 71.3865 275.548ZM71.3865 268.069C75.7478 268.069 78.4278 264.767 78.4278 258.597C78.4278 252.427 75.7478 249.126 71.3865 249.126C66.9615 249.126 64.2815 252.428 64.2815 258.597C64.2815 264.766 66.9615 268.069 71.3865 268.069Z",
    fill: "#152845"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M123.981 252.989V274.551H114.01V256.167C114.01 251.368 112.328 249.748 109.025 249.748C105.224 249.748 103.043 251.681 103.043 256.104V274.551H93.0713V242.644H103.043V247.256H103.168C104.85 244.327 107.965 241.647 113.636 241.647C119.806 241.647 123.981 245.698 123.981 252.989Z",
    fill: "#152845"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M150.902 264.892H160.81C159.06 271.309 154.08 275.548 145.418 275.548C134.824 275.548 128.405 268.568 128.405 258.597C128.405 248.876 134.699 241.647 144.857 241.647C155.763 241.647 161.309 249.623 161.309 261.214H138.375C138.375 265.702 141.678 268.069 145.23 268.069C148.658 268.069 150.279 266.449 150.902 264.892ZM138.375 255.169H151.338C151.338 250.746 148.658 248.502 144.857 248.502C141.055 248.502 138.375 250.746 138.375 255.169Z",
    fill: "#152845"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M184.616 275.173C181.875 283.337 178.882 285.587 172.152 285.587C170.287 285.575 168.428 285.365 166.606 284.962V277.485H166.731C169.473 278.11 171.716 277.796 172.775 276.176C173.71 274.742 173.525 272.748 172.525 269.945L162.125 242.645H172.096L179.319 263.587H179.444L185.489 242.648H195.459L184.616 275.173Z",
    fill: "#152845"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M219.7 234.107C209.106 234.107 204.619 243.891 204.619 252.241C204.619 260.653 207.86 270.438 219.076 270.438C227.054 270.438 233.596 264.705 233.596 256.355H219.076V251.368H239.201V274.551H235.462L233.587 268.257H233.462C230.096 272.931 225.921 275.423 219.066 275.423C206.105 275.423 199 265.702 199 252.241C199 238.843 207.351 229.122 219.69 229.122C230.969 229.122 236.889 234.98 238.448 243.455H232.839C231.54 237.098 226.43 234.107 219.7 234.107Z",
    fill: "#152845"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M248.179 229.995H265.875C274.039 229.995 280.333 233.608 280.333 242.956C280.333 252.303 274.039 255.918 265.875 255.918H253.785V274.551H248.178L248.179 229.995ZM253.786 250.932H266.5C272.046 250.932 274.727 248.377 274.727 242.956C274.727 237.534 272.046 234.979 266.5 234.979H253.788L253.786 250.932Z",
    fill: "#152845"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M319.594 262.897C319.594 269.378 314.795 275.423 303.515 275.423C292.984 275.423 284.82 269.815 284.197 259.595H289.806C290.431 265.702 294.167 270.438 303.515 270.438C311.242 270.438 313.985 266.886 313.985 262.897C313.985 256.791 310.682 255.668 300.711 253.363C294.043 251.805 286.066 249.5 286.066 240.837C286.066 233.796 291.488 229.122 301.335 229.122C310.806 229.122 317.412 233.982 318.16 243.206H312.551C311.741 237.223 308.376 234.107 301.335 234.107C295.04 234.107 291.675 236.537 291.675 240.215C291.675 246.135 296.473 246.945 303.017 248.565C313.05 251.057 319.594 252.74 319.594 262.897Z",
    fill: "#152845"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2964_3553",
    x1: 114.654,
    y1: 146.743,
    x2: 78.7494,
    y2: 173.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5200B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133CA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2964_3553",
    x1: 212.146,
    y1: 38.6655,
    x2: 110.092,
    y2: 175.129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C60A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9313FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2964_3553",
    x1: 118.903,
    y1: 106.03,
    x2: 200.475,
    y2: 106.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50E1C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6E885"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2964_3553",
    x1: 114.757,
    y1: 129.251,
    x2: 154.609,
    y2: 113.958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B8C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67E785"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2964_3553",
    x1: 149.412,
    y1: 69.7333,
    x2: 152.822,
    y2: 69.7333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B8C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6DA887"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2964_3553",
    x1: 29129.8,
    y1: 8539.85,
    x2: 30910.1,
    y2: 8539.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B8C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6DA887"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2964_3553",
    x1: 15672.7,
    y1: 7739.67,
    x2: 16141.5,
    y2: 7739.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B8C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6DA887"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2964_3553",
    x1: 37800.1,
    y1: 37713.9,
    x2: 41025.1,
    y2: 37713.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B8C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6DA887"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2964_3553",
    x1: 36257.7,
    y1: 23638.3,
    x2: 39133.2,
    y2: 23638.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B8C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6DA887"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2964_3553",
    x1: 52233.1,
    y1: 50172.3,
    x2: 50358.1,
    y2: 61381.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50E1C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6E885"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyGpsNavyText);
export default __webpack_public_path__ + "static/media/moneyGPS-navy-text.c3bb729c316c2e8260af7c9db75f2b7f.svg";
export { ForwardRef as ReactComponent };